import React from "react";
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import MultiGame from './multi-game';
import SingleGame from './single-game';
import GameOver from './game-over';
import styles from './game-style.scss.js';
import { observer } from 'mobx-react';
import { observableSingleStore } from '../stores/single-store';
import { observableIntervalStore } from '../stores/interval-store';
import { observableChordStore } from '../stores/chord-store';
import { observableUIStore } from '../stores/ui-store';
import { observableTutorialStore } from '../stores/tutorial-store';
import { observableProgressStore } from '../stores/user-level-progress-store';
const  ReactGA = require('react-ga');

@observer
export default class AdventureGame extends React.Component {
  constructor(props) {
    super(props);
    this.checkAnswer = this.checkAnswer.bind(this);
    this.playSource = this.playSource.bind(this);
    this.playTuned = this.playTuned.bind(this);
    this.changeHelp = this.changeHelp.bind(this);
    this.practice = this.practice.bind(this);
    this.goToNextLevel = this.goToNextLevel.bind(this);
    this.playSourceTouch = this.playSourceTouch.bind(this);
    this.playTunedTouch = this.playTunedTouch.bind(this);
    this.submitTouchStart = this.submitTouchStart.bind(this);
    this.tutorialNextTouch = this.tutorialNextTouch.bind(this);
    this.changeHelpTouch = this.changeHelpTouch.bind(this);
    this.practiceTouch = this.practiceTouch.bind(this);
    this.goToNextLevelTouch = this.goToNextLevelTouch.bind(this);

  }
  checkAnswer() {
    this.props.store.checkAnswer();
  }
  submitTouchStart(e) {
    this.checkAnswer();
    e.preventDefault();
  }
  playSource() {
    this.props.store.currentStore.currentStage.playAllFixed();
    ReactGA.event({
      category: 'Game',
      action: 'Play Source'
    });
  }
  playTuned() {
    this.props.store.currentStore.currentStage.playAllTuned();
    ReactGA.event({
      category: 'Game',
      action: 'Play Tuned'
    });
  }
  practice() {
    this.props.store.showClearedMessage = false;
  }
  practiceTouch(e) {
    this.practice();
    e.preventDefault();
  }
  goToNextLevel(e) {
    this.props.store.goToNextLevel();
  }
  goToNextLevelTouch(e) {
    this.goToNextLevel();
    e.preventDefault();
  }
  changeHelp() {
    const level = this.props.store.level;
    const levelOuterObject = observableTutorialStore.getObjectForLevel(level);
    const showHelp = levelOuterObject.show;
    observableTutorialStore.setShowHelp(this.props.store.level,
      !showHelp);
  }
  changeHelpTouch(e) {
    e.preventDefault();
    this.changeHelp();
  }
  playSourceTouch(e) {
    e.preventDefault();
    this.playSource();
  }
  playTunedTouch(e) {
    e.preventDefault();
    this.playTuned();
  }
  tutorialNextTouch(e) {
    e.preventDefault();
    observableTutorialStore.nextPressed(this.props.store.level);
  }
  componentWillMount() {
  }
  render() {
    const level = this.props.store.level;
    const showNext = observableProgressStore.state[level];
    const levelOuterObject = observableTutorialStore.getObjectForLevel(level);
    const levelObject = levelOuterObject.details[levelOuterObject.index];
    const showHelp = levelOuterObject.show;
    const showCleared = this.props.store.showClearedMessage;
    const highlightIds = levelObject.hightlightIds;
    let game = null;
    if (this.props.store.currentStore === observableSingleStore) {
        game = <SingleGame store={observableSingleStore.currentStage} uistore={observableUIStore} />;
    }
    else if (this.props.store.currentStore === observableIntervalStore) {
        game = <MultiGame highlightIds={showHelp? highlightIds : []} key="interval-multi" store={observableIntervalStore.currentStage} uistore={observableUIStore} />;
    }
    else {
        game = <MultiGame highlightIds={showHelp? highlightIds : []} key="chord-multi" store={observableChordStore.currentStage} uistore={observableUIStore} />;
    }
    if (this.props.store.lives <= 0) {
      ReactGA.event({
          category: 'Game',
          action: 'Ended'
      });
      ReactGA.event({
        category: 'Game',
        action: 'Result',
        label: 'Single',
        value: observableSingleStore.numberCorrect
      });
      ReactGA.event({
        category: 'Game',
        action: 'Result',
        label: 'Interval',
        value: observableIntervalStore.numberCorrect
      });
      ReactGA.event({
        category: 'Game',
        action: 'Result',
        label: 'Triad',
        value: observableChordStore.numberCorrect
      });
      return (
        <GameOver store={this.props.store}/>
          );

    }
    return (
      <div>
        {game}
        {showHelp?
            <div className="tutorial-controls"
              style={{display: "flex", position: "absolute", flexDirection: "column", overflow: "hidden", pointerEvents: 'none',
                top: 0, left: 0, right: 0, bottom: 0, zIndex: 4, justifyContent: 'center', alignItems: 'center'}}>
                <div style={{display: 'flex', justifyContent: 'center',
                  alignItems: 'center', flexDirection: 'column',
                  backgroundColor: 'rgba(255, 255, 255, 1.0)', border: "1px solid #888585", maxWidth: '50%', padding: 20}}>
                  <p style={{textAlign: "center"}}>{levelObject.content}</p>
                  <button className="swell-repeat"
                    onTouchStart={this.tutorialNextTouch} onClick={() => observableTutorialStore.nextPressed(level)}>
                    {levelOuterObject.index < levelOuterObject.details.length - 1? "Next": "Done"}</button>
                </div>
              </div>
            :
            null}
            <div className="normal-controls"
              style={{display: "flex", position: "absolute", overflow: "hidden", pointerEvents: 'none',
                top: 0, left: 0, right: 0, bottom: 0, zIndex: 3, ...styles.container}}>
                <div className="first-column column-flex outer-column">
                  <span>Level: {this.props.store.level}</span>
                  <button className={`bottom-button side-button ` +
                      `${showHelp && levelObject
                .hightlightIds.includes("play-source")? "swell-repeat": ""}`}
                onTouchStart={this.playSourceTouch}
                onClick={this.playSource}>►</button>
            </div>
            <div className="column-flex" style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: "100%"}}>
              <div className="chord-name">{this.props.store.currentStore.currentStage.label}</div>
              <ReactCSSTransitionGroup
                transitionName="correct"
                transitionEnterTimeout={500}
                transitionLeaveTimeout={250}>
                {this.props.store.showCorrect?
                  <div key={"celebrate"} className='congrats' style={{textAlign: 'center'}}>✓</div>
                  :
                  null
                }
              </ReactCSSTransitionGroup>
              <ReactCSSTransitionGroup
                transitionName="incorrect"
                transitionEnterTimeout={500}
                transitionLeaveTimeout={250}>
                {this.props.store.showIncorrect?
                  <div key={"ohno"} className="wrong" style={{textAlign: 'center'}}>X</div>
                  :
                  null
                }
              </ReactCSSTransitionGroup>
              <button className={`submit bottom-button `}
                onTouchStart={showHelp? null : this.submitTouchStart} disabled={showHelp} onClick={this.checkAnswer} style={{...styles.submit}}>Submit</button>
            </div>
            <div className="column-flex outer-column last-column">
              <span>Lives: {this.props.store.lives}</span>
              <button className={`bottom-button side-button ` +
                  `${showHelp && levelObject
                .hightlightIds.includes("play-tuned")? "swell-repeat": ""}`}
                onTouchStart={this.playTunedTouch} onClick={this.playTuned}>►</button>
            </div>
          </div>
          <div className="help-controls"
            style={{display: "flex", position: "absolute", overflow: "hidden",
              pointerEvents: 'none', top: 0, left: 0, right: 0, bottom: 0,
              justifyContent: 'center', flexDirection: 'row', zIndex: 4}}>
              <button onTouchStart={this.changeHelpTouch}
                className="help-button"
                onClick={this.changeHelp}>?</button>

            </div>
          <div className="next-controls"
            style={{display: "flex", position: "absolute", overflow: "hidden",
              pointerEvents: 'none', top: 0, left: 0, right: 0, bottom: 0,
              justifyContent: 'center', flexDirection: 'row', zIndex: 5}}>
              {showNext?
              <button onTouchStart={this.goToNextLevelTouch}
                className="next-button next-level-button"
                onClick={this.goToNextLevel}>Level {level+1} ></button>
                : null}

            </div>
          <div className="next-menu"
            style={{display: "flex", position: "absolute", overflow: "hidden",
              pointerEvents: 'none', top: 0, left: 0, right: 0, bottom: 0,
              justifyContent: 'center', flexDirection: 'column',
              alignItems: 'center', zIndex: 5}}>
              {showCleared?
                <div style={{display: 'flex', justifyContent: 'center',
                  alignItems: 'center', flexDirection: 'column',
                  backgroundColor: 'rgba(255, 255, 255, 1.0)', border: "1px solid #888585", maxWidth: '66%', padding: 10}}>
                  <div>
                    Level {level} Cleared!
                  </div>
                  <div style={{flexDirection: 'row', justifyContent: 'space-between'}}>
                    <button onTouchStart={this.practiceTouch}
                      className="next-menu-button"
                      onClick={this.practice}>Practice</button>
                    <button onTouchStart={this.goToNextLevelTouch}
                      className="next-menu-button next-level-button"
                      onClick={this.goToNextLevel} >Level {level+1} ></button>
                  </div>
                </div>
                : null}

            </div>
          </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/adventure-game.js